module.exports = __webpack_public_path__ + "static/media/service-card-img.7dd8c8d0.svg";